/**
 * 活动主入口，主要做一些全局处理和设置，本JS一般不需要修改
 * 已自动加载jQuery、template模块，可直接使用$、template
 */
import checkSize from 'mihoyo-checksize'; // 老版checksize的优化版，请勿再手动引入checksize了
import '../css/main.css'; // 活动样式，别的样式在main.css里面直接@import
import './lib';
import mainView from './views/main'; // 视图主入口，它负责组织别的视图

// 根据当前环境选择性加载 mock 包，发布的时候也不用注释和删除
if(process.env.NODE_ENV === 'development') {
  require('./mock');
}

checkSize({
  widthParam: 659,
  heightParam: 336,
  //widthParam与heightParam为checksize所需宽高比，不传则为崩坏3webview活动带顶栏的比例
  //常用比例：
  //崩2 16：9
  //崩3全屏 16：9
  //崩3小窗 & 崩3带顶栏 659：336 （不传即可）
  horizonScreen: true,
  callback: () => {
    // frame 默认是hidden的，checksize完成后，再visible，避免页面checksize前后页面错位抖动
    $('#frame').css('visibility', 'visible');
  }
  //callback为checksize完成后的回调
});

$(function () {
  // vconsole 根据环境和url控制，线上环境也可以
  const $vconsole = $('#vconsole');

  if(process.env.NODE_ENV === 'development'
    || location.search.indexOf('debug=1') > -1
    || location.host.indexOf('-test') > -1) {
    $vconsole.on('load', () => {
      new window.VConsole();
      mainView.render(); // 等待vconsole初始化完成，再初始化视图，以免漏掉一些请求监听
    });
    $vconsole.attr('src', $vconsole.attr('data-src'));
  } else {
    mainView.render(); // 视图初始化入口
    $vconsole.remove();
  }
});



